//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/ErrorPage/PageNotFound";

import DashboardLayout from "../layouts/DashboardLayout";
import PrivateRoute from "./PrivateRoute";
import UserRole from "../pages/UserRole";
//@ts-ignore
import {
  PermissionRequired,
  AccessControl,
} from "@careinfo/permission-required";
//@ts-ignore
import { RoleRouterService } from "@careinfo/role";

//@ts-ignore
import { UserRouterService } from "@careinfo/user";
import { WelcomeRouterService } from "@careinfo/welcome-page-service";
import { getKey } from "../helpers/sessionKey";
import FiscalYear from "../pages/FiscalYear/FiscalYear";
import Branch from "../pages/Branch/Branch";
import EditBranch from "../pages/Branch/EditBranch";

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path={"/overview"} element={<UserRole />} />
        <Route
          path={"/"}
          element={
            shouldShowWelcome === "true" || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <UserRole />
            )
          }
        />
        <Route
          path={"/roles"}
          element={
            <AccessControl
              children={<RoleRouterService />}
              allowedPermissions={["can_view_group"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/users"}
          element={
            <AccessControl
              children={<UserRouterService />}
              allowedPermissions={["can_view_user"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/fiscal-year"}
          element={
            <AccessControl
              children={<FiscalYear />}
              allowedPermissions={["can_view_user"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/branch"}
          element={
            <AccessControl
              children={<Branch />}
              allowedPermissions={["can_view_user"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/branch/edit/:id"}
          element={
            <AccessControl
              children={<EditBranch />}
              allowedPermissions={["can_view_user"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
